var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypeEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.981 11.41V1.375H0V11.41c0 6.194 4.82 11.215 10.767 11.215 5.946 0 10.766-5.021 10.766-11.215V1.375h-5.981V11.41c0 2.753-1.657 5.312-4.785 5.312S5.98 14.162 5.98 11.41Zm23.234 0V1.375h-5.982V11.41c0 6.194 4.82 11.215 10.767 11.215 5.946 0 10.767-5.021 10.767-11.215V1.375h-5.982V11.41c0 2.753-1.78 5.312-4.785 5.312-3.006 0-4.785-2.56-4.785-5.312ZM57.233 1.375C63.18 1.375 68 6.132 68 12s-4.82 10.625-10.767 10.625H46.467V1.375h10.766Zm.282 5.312h-5.067v10.625h5.067c2.361 0 4.503-2.378 4.503-5.312s-2.142-5.313-4.503-5.313Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeEn);
export default __webpack_public_path__ + "static/media/logotype_en.faad1ef5a995a2f49581fe5f567f4e53.svg";
export { ForwardRef as ReactComponent };